import { teams } from "./tems-list";
export const GetProgram = (games) => {
  if (games && games.length > 0) {
    const gamesMap = games.map((z, index) => {
      return {
        num: index + 1,
        idGame: z.idGame,
        away: {
          team: teams?.find((item) => item.symbol == z.away.symbol).code,
          symbol: teams?.find((item) => item.symbol == z.away.symbol).symbol,
          picher: z.picher.away,
          rate: z.line.jc.away,
          k: z.line.k.away,
          s: z.line.s.away,
          rl: { da: z.line.rl.away.da, rate: z.line.rl.away.rate },
          p: { da: z.line.p.away.da, rate: z.line.p.away.rate },
        },
        home: {
          team: teams?.find((item) => item.symbol == z.home.symbol).code,
          symbol: teams?.find((item) => item.symbol == z.home.symbol).symbol,
          picher: z.picher.home,
          rate: z.line.jc.home,
          k: z.line.k.home,
          s: z.line.s.home,
          rl: { da: z.line.rl.home.da, rate: z.line.rl.home.rate },
          p: { da: z.line.p.home.da, rate: z.line.p.home.rate },
        },
        state: z.state,
        code: "",
        runs: z.line.jc.runs,
      };
    });
    return gamesMap;
  }
};
